// react
import React from 'react'

//hooks
import { useRetractSidebar } from '_hooks'

// components
import { TabbedViews, Form } from '@st-operations/uikit/src/v2/index.js'
import ListView from '_components/list-view/index.jsx'
import EntityEditForm from '_components/entity-edit-form/index.jsx'

const CompanyPage = (props) => {
  useRetractSidebar()

  return (
    <div id="company-page">
      <EntityEditForm entities="companies" id={props.match.params.id} resource="Companies">
        {({ disabled, item, onChange, schema }) => (
          <TabbedViews key={item._id}>
            <Form
              title="Metadata"
              item={item}
              onChange={onChange}
              schema={schema}
              fields={[
                { name: 'name' },
                { name: 'products' },
                { name: 'account_manager' },
                { name: 'reporting_delay' },
              ]}
              disabled={disabled}
            />
            <ListView
              title="People"
              columns={[
                {
                  key: 'name',
                  link: '/people/:_id',
                  name: 'Name',
                  sortable: true,
                },
                {
                  key: 'company.name',
                  link: '/companies/:_id',
                  name: 'Company',
                },
                {
                  name: 'Department',
                  key: 'department',
                },
                {
                  key: 'position',
                },
              ]}
              queryString={{ 'company._id': item._id }}
              entities="people"
              searchable={true}
              sort_key={'name'}
              stateful={false}
            />

            <ListView
              title="Destinations"
              columns={[
                {
                  key: 'name',
                  link: '/destinations/:_id',
                  name: 'Name',
                  sortable: true,
                },
                {
                  name: 'Code',
                  key: 'code',
                  sortable: true,
                },
                {
                  format: 'percent',
                  key: 'match_rate',
                  name: 'Match Rate',
                },
                {
                  format: 'yes/no',
                  key: 'allow_custom',
                  name: 'Allow Custom',
                },
              ]}
              queryString={{ 'company._id': item._id }}
              entities="destinations"
              searchable={true}
              sort_key={'name'}
              stateful={false}
            />

            <ListView
              title="Data Feeds"
              columns={[
                {
                  key: 'name',
                  link: '/data-feeds/:_id',
                  name: 'Name',
                  sortable: true,
                },
                {
                  name: 'Company',
                  key: 'company.name',
                  link: '/companies/:company._id',
                },
                {
                  name: 'Created by',
                  key: 'created_by.email',
                },
                {
                  format: 'date',
                  key: 'created_at',
                  name: 'Created on',
                  sortable: true,
                },
              ]}
              queryString={{ 'company._id': item._id }}
              entities="data-feeds"
              searchable={true}
              sort_key={'name'}
              stateful={false}
            />

            <ListView
              title="Links"
              columns={[
                {
                  key: 'name',
                  link: '/links/:_id',
                  name: 'Name',
                  sortable: true,
                },
                {
                  name: 'URL',
                  key: 'url',
                  href: ':url',
                },
                {
                  name: 'Category',
                  key: 'category',
                },
              ]}
              queryString={{ 'company._id': item._id }}
              entities="links"
              searchable={true}
              sort_key={'name'}
              stateful={false}
            />
          </TabbedViews>
        )}
      </EntityEditForm>
    </div>
  )
}

export default CompanyPage
